export const colorTokens = [
  'bg-app',
  'bg-shell',
  'bg-sidebar',
  'bg-panel',
  'bg-panel-soft',
  'bg-card',
  'text-primary',
  'text-secondary',
  'border',
  'accent',
  'accent-contrast',
  'success',
  'shadow-color'
];

export const themeColors = {
  light: {
    'bg-app': '#f3f5fb',
    'bg-shell': '#ffffff',
    'bg-sidebar': '#eef2ff',
    'bg-panel': '#f7d7ff',
    'bg-panel-soft': '#eb78b8',
    'bg-card': '#ffffff',
    'text-primary': '#1f2440',
    'text-secondary': '#57607d',
    border: '#d9def0',
    accent: '#6f4bff',
    'accent-contrast': '#ffffff',
    success: '#26a269',
    'shadow-color': '#a5afd8'
  },
  dark: {
    'bg-app': '#090d18',
    'bg-shell': '#10172b',
    'bg-sidebar': '#161f38',
    'bg-panel': '#4f4ca6',
    'bg-panel-soft': '#873a88',
    'bg-card': '#1d2846',
    'text-primary': '#eef2ff',
    'text-secondary': '#b7c2ea',
    border: '#2a365a',
    accent: '#9780ff',
    'accent-contrast': '#091023',
    success: '#4de5a7',
    'shadow-color': '#05070f'
  }
};
